import React from "react";
import { GrDirections } from "react-icons/gr";
import {
  Popup,
  //Button,
} from "semantic-ui-react";

const ContactUs = () => {
  //*************** */
  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  //^^^^^^^^^^
  const renderDirectionButton = (add) => (
    <Popup
      content={"Get directions to this location on Google Map "}
      disabled={renderPopupState()}
      trigger={
        <a target="_blank" rel="noreferrer noopener" className="bt font-16B" href={`${add}`}
		
		>
          <GrDirections className="font-16B" />{" "}
          Directions
        </a>
      }
    />
  );
  //*************** */
  return (
    <section className="padding-gr-outer bgColor-gr2 ">
      
          <div className="inner-gr bgColor-gr2 font-family-Nunito ">
            <div className="headtitl">
              <div
                className="font-36B color-CornflowerBlue"
              >
                 <span>Contact Us?</span>
              </div>
              
              <div className="devider">
               
              </div>
            </div>

            <div className="flex-center direction-r2c text-align-center">
              <div className="card-contact text-align-center">
                
                <div>
                  <h4 className="textAlign-center">Visit Our Office</h4>
                 
      <p>
      <b>HEAD OFFICE</b> <br/>Plot No 485-486 Sector 19 <br/>Dwarka New Delhi 110075<br/>Near ICICI Bank And Opp Max Hospital<br/>
      {renderDirectionButton('https://maps.app.goo.gl/k1btpuBwNarM1R5E6')}<br/><br/>
      <b>BRANCH OFFICE</b><br/>Rajendra Park Main <br/> Dwarka Expressway <br/>Sector 105 Gurugram 122001 <br/>Opp Paras Dews <br/>
      {renderDirectionButton('https://maps.app.goo.gl/1sCseaPJzKM3mXTJ7')}
      </p>
                </div>
              </div>
              <div className="card-contact">
                
                <div className="textchoose">
                  {/* <h4 className="textAlign-center">One Stop Solution</h4> */}
                  <h4>Let’s call us</h4>
      <p>
      
      <b>Sahil Gupta</b> 9910223322<br/><br/>
      <b>Manager Dwarka Office</b><br/>
      Jamal Aktar<br/>9311905859<br/><br/>
      <b>Manager Dwarka Expressway Office</b><br/>
      Rohit Tiwari <br/> 8882444612<br/>

      
      
      </p>
                </div>
              </div>
              <div className="card-contact">
                
                <div className="textchoose">
                <h4>Let’s Email Us</h4>
      <p>
      <b>Dwarka Office</b><br/>info@guptarealtors.com<br/><br/>  
      <b>Dwarka Expressway Office </b> guptarealtorsdwk@gmail.com <br/> <br/>    
       <b>Sahil Gupta</b><br/>sahilgupta59@yahoo.com


      
      
      
      </p>
                </div>
              </div>

              <div className="card-contact">
                
                <div className="textchoose">
                <h4>Customer Support</h4>
      <p>
      <b>Dwarka</b><br/> Ankit Singh 9810653653<br/><br/>
      <b>Dwarka Expressway </b><br/>Prateek Sangwan 9899610004


      </p>
                </div>
              </div>
            </div>
          </div>
       
    </section>
  );
};

export default ContactUs;
